import { mutationTypes } from '@/types';
import { syncActionStates } from '@/tools/consts';

export function setSubPartStateFromLocalstorage({ commit, getters }) {
	// Update the states of sub parts that are already offline from a previous session
	const selectedSubParts = localStorage.selectedSubParts ? JSON.parse(localStorage.selectedSubParts) : {};
	Object.entries(selectedSubParts).forEach(([subPartId, state]) => {
		commit(mutationTypes.packageSyncerSetSubPartState, {
			subPartId,
			subPartState: state === true || state === getters.currentLanguage ? syncActionStates.loaded : null,
		});
	});
}
